const baseApi = process.env.VUE_APP_BASE_API || '/app-api'
const adminBaseApi =
  process.env.VUE_APP_ADMIN_BASE_API || String(baseApi).replace(/\/app-api\/?$/, '/admin-api')

/** 天地图 Web JS API（.env 变更后需重启 npm run serve） */
const tiandituTk = process.env.VUE_APP_TIANDITU_TK || ''
const tiandituSk = process.env.VUE_APP_TIANDITU_SK || ''

export default {
  baseApi,
  adminBaseApi,
  tiandituTk,
  tiandituSk,
}
